import { render, staticRenderFns } from "./drawermenu-element.vue?vue&type=template&id=562cc824&scoped=true&"
import script from "./drawermenu-element.vue?vue&type=script&lang=js&"
export * from "./drawermenu-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562cc824",
  null
  
)

export default component.exports